// Direct-to-Blob upload (bundle 4a-2): the API hands out one short-lived write-only SAS URL per file; the browser PUTs
// the file straight to Azure Blob with progress, at most `concurrency` at a time. Nothing goes through the API.

export function putFile(upload, file, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(upload.method || 'PUT', upload.url);
    Object.entries(upload.headers || {}).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    xhr.upload.onprogress = (e) => { if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100)); };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
    xhr.onerror = () => reject(new Error('Upload failed — check your connection (or the storage CORS rule)'));
    xhr.send(file);
  });
}

export async function runPool(items, concurrency, worker) {
  let next = 0;
  const lanes = Array.from({ length: Math.min(concurrency, items.length) }, async () => {
    while (next < items.length) {
      const i = next;
      next += 1;
      await worker(items[i], i);
    }
  });
  await Promise.all(lanes);
}

export const ACCEPT = '.pdf,.docx,.doc,.txt,.zip,.csv';
export const RESUME_ACCEPT = '.pdf,.docx,.doc,.txt';

export function kindOf(name) {
  const ext = (name.split('.').pop() || '').toLowerCase();
  if (ext === 'zip') return 'zip';
  if (ext === 'csv') return 'csv';
  return ['pdf', 'docx', 'doc', 'txt'].includes(ext) ? 'file' : '';
}

export function sizeLabel(bytes) {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

// Register → upload every file → start. onFile(i, patch) reports {progress, state, error}. Returns the import id.
export async function uploadBatch(api, files, { requirementId, tags, single, onFile, concurrency = 4 } = {}) {
  const reg = await api('/api/candidate-imports', {
    method: 'POST',
    body: { files: files.map((f) => ({ name: f.name, size: f.size })), requirement_id: requirementId || null, tags: tags || [], single: !!single },
  });
  await runPool(reg.uploads, concurrency, async (u, i) => {
    onFile && onFile(i, { state: 'uploading', progress: 0 });
    try {
      await putFile(u, files[i], (p) => onFile && onFile(i, { progress: p }));
      onFile && onFile(i, { state: 'uploaded', progress: 100 });
    } catch (e) {
      onFile && onFile(i, { state: 'error', error: e.message });
    }
  });
  await api(`/api/candidate-imports/${reg.import_id}/start`, { method: 'POST' });
  return reg.import_id;
}
